import React, { Component } from 'react'
import PropTypes from 'prop-types'

import {
  ExpandableInfo,
  ServiceListInspect,
  ServiceModelDetails
} from 'containers'

import { BackButton, P, H3, H5, H4, Section } from 'AtomicComponents'

import { withRadium, DetectCompact } from 'higher-order-components'
import { get } from 'utils'

import ServiceBasePrice from './service-base-price'

class ServiceDetailsFullContainer extends Component {
  static propTypes = {
    data: PropTypes.object,
    factoryCode: PropTypes.string,
    additionalCodes: PropTypes.array,
    termsAndConditions: PropTypes.string,
    compact: PropTypes.bool
  }

  static defaultProps = {
    data: {},
    factoryCode: '',
    additionalCodes: []
  }

  constructor(props) {
    super(props)
    this.state = {}
    this.selectedAdditionalServices = {}
    props.additionalCodes &&
      props.additionalCodes.forEach((c) => {
        this.selectedAdditionalServices[c] = true
      })
  }

  getMainService() {
    return (get('data.serviceItems', this.props) || [])
      .filter(s => s.factoryCodeEntity.type.match(/Scheduled/))
      .filter((s, index) => {
        if (this.props.factoryCode) {
          return s.factoryCodeEntity.code === this.props.factoryCode
        }
        return index === 0
      })
      .map((s) => {
        const m = /([^\s]+) Service or (.+)/.exec(s.factoryCodeEntity.description)
        return {
          name: m ? `${m[1]} Service | $${s.basePrice}` : s.factoryCodeEntity.description,
          extraLabel: m ? `${m[2]} or ${s.factoryCodeEntity.time}m` : '',
          price: `$${s.basePrice}`,
          shortName: m ? `${m[1]} Service` : s.factoryCodeEntity.description,
          code: s.factoryCodeEntity.code,
          item: s
        }
      })[0]
  }

  getAdditionalServices() {
    return (get('data.serviceItems', this.props) || [])
      .filter(s =>
        s.factoryCodeEntity.type === 'Additional Scheduled Maintenance' &&
          s.factoryCodeEntity.distance > 0)
      .map(s => ({
        name: s.factoryCodeEntity.description,
        description: s.operationActions[0].operations[0].description,
        price: `$${s.basePrice}`,
        code: s.factoryCodeEntity.code
      }))
  }

  renderLinkBack() {
    let url = this.props.backLink
    if (this.props.data.vehicle.vin) {
      url = `/owners/servicing/owners-service-calculator/?VIN=${this.props.data.vehicle
        .vin}&factoryCode=${this.props.factoryCode}`
    }
    return (
      <BackButton
        href={url}
        backText="BACK TO SERVICING" />
    )
  }

  isSPG() {
    try {
      // trying to guess MSS vs SPG service type
      // MSS factoryCode starts with 'S' and SPG starts with 'M' (yes, it's counterintuitive)
      return (
        this.props.data &&
        this.props.data.serviceItems.some(si => si.factoryCodeEntity.code[0] === 'M')
      )
    } catch (e) {
      if (process.env.NODE_ENV === 'development') console.log(e)
      return false
    }
  }

  _findNonZeroDistance = () =>{
    let distance = 0
    this.props.data && this.props.data.serviceItems.forEach(item=>{
      if (item.factoryCodeEntity.distance > 0 && distance === 0 ){
        distance = item.factoryCodeEntity.distance
      }
    })
    return distance
  }

  render() {
    const { data, compact } = this.props
    const mainService = this.getMainService()
    const additionalServices = this.getAdditionalServices()
    const vehicle = data.vehicle
    // /service-details?serviceSpecCode=GL20SH0DA10&factoryCode=S030
    // we had some rule for some reason earlier to hide price for all Owner results (e.i with vin number)
    const hidePrice = false
    const spg = this.isSPG()
    // only display price in top header for SPG results
    const serviceTitle = spg
      ? `${mainService.item.factoryCodeEntity.description} - $${mainService.item.basePrice}`
      : mainService.item.factoryCodeEntity.description
    const km = this._findNonZeroDistance().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    const baseScheduleHeading = spg ? 'Scheduled Maintenance' : 'Base Scheduled Maintenance'
    const baseScheduleDescription = spg
      ? `Regular servicing is the key to maintaining your investment, which is why it’s important you return every ${km} kms. To ensure your car receives the best and most appropriate service schedule, you should consult your Mazda Dealer.`
      : `Base scheduled maintenance is due every ${km} km, but no longer than 12 months, whichever comes first.`
    return (
      <Section horizontalPadding center={false} backgroundColor="#f5f5f5">
        <div style={styles.base(compact)}>
          <div style={{ alignSelf: "flex-start" }}>
            {this.renderLinkBack()}
          </div>
          <div style={styles.mainServiceHeader(compact)}>
            <H3 withDetails>SERVICE DETAILS</H3>
            {
              vehicle.modelGroup &&
              vehicle.vin &&
              vehicle.grade &&
              vehicle.rego && (
                <ServiceModelDetails
                  model={`${vehicle.modelGroup} ${vehicle.grade}`}
                  vin={vehicle.vin}
                  registration={vehicle.rego && vehicle.rego != 'null' ? vehicle.rego : ''}
                  compact={compact} />
              )}
          </div>

          <div style={styles.serviceSummary}>
            <div
              style={{
                background: "#fff",
                padding: "2em"
              }}>
              <H5 withDetails>{serviceTitle}</H5>
              <P withoutMargin>{baseScheduleDescription}</P>
            </div>
          </div>

          <div style={styles.serviceListContainer(compact)}>
            <H3>{baseScheduleHeading}</H3>
            {mainService.item.operationActions.length &&
              mainService.item.operationActions.map((category, i) => (
                <div key={category.name} style={styles.listSection(i === 0)}>
                  <H5>{category.name}</H5>
                  <ServiceListInspect services={category.operations} compact={compact} />
                </div>
              ))}
            {!hidePrice && (
              <div
                style={{
                  textAlign: 'right',
                  padding: '2em 0',
                  borderTop: '1px solid #aaa'
                }}>
                <ServiceBasePrice service={mainService.item} compact={compact} />
              </div>
            )}
            {additionalServices.length ? (
              <div id="item-details">
                <H4>ADDITIONAL SCHEDULED MAINTENANCE</H4>
                <ServiceListInspect services={additionalServices} compact={compact} />
              </div>
            ) : (
              ''
            )}
          </div>
          <div style={{ padding: '2em' }}>
            <div style={{ maxWidth: '70em', margin: 'auto' }}>
              <ExpandableInfo
                color="#cccccc"
                mainText="Read full terms and conditions"
                description={this.props.termsAndConditions} />
            </div>
          </div>
        </div>
      </Section>
    )
  }
}

export default withRadium(DetectCompact())(ServiceDetailsFullContainer)

const styles = {
  base: compact => ({
    flexDirection: 'column',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    boxSizing: 'border-box'
  }),

  serviceSummary: {
    backgroundColor: 'white',
    borderRadius: '4px',
    border: 'solid #999 1px',
    marginTop: '1em',
    width: '100%'
  },

  serviceListContainer: compact => ({
    width: '100%',
    boxSizing: 'border-box',
    margin: 'auto',
    padding: compact ? 0 : '0 2em'
  }),

  mainServiceHeader: compact => ({
    marginTop: '1em',
    textAlign: "center"
  }),

  listSection: isFirst => ({
    margin: isFirst ? '1em 0 0' : '5em 0 0',
    borderBottom: '1px solid #aaa'
  }),

  listSectionTitle: {
    display: 'block',
    fontSize: '1.2em',
    margin: '0 0 0.9em 0',
    textTransform: 'uppercase',
    letterSpacing: '0.1em',
    fontFamily: 'inherit'
  }
}



// WEBPACK FOOTER //
// ./src/containers/service-details-full/index.jsx